const industries = [
  {
    displayName: 'Automotive',
    value: 'AUTOMOTIVE',
  },
  {
    displayName: 'Construction',
    value: 'CONSTRUCTION',
  },
  {
    displayName: 'Cosmetics',
    value: 'COSMETICS',
  },
  {
    displayName: 'Food & Beverages',
    value: 'FOOD',
  },
  {
    displayName: 'Paper and Packaging',
    value: 'PAPER_AND_PACKAGING',
  },
  {
    displayName: 'Pharmaceutical',
    value: 'PHARMACEUTICAL',
  },
  {
    displayName: 'Retail',
    value: 'RETAIL',
  },
  {
    displayName: 'Textile and Fashion',
    value: 'TEXTILE_AND_FASHION',
  },
  {
    displayName: 'Wood and Furniture',
    value: 'WOOD_AND_FURNITURE',
  },
];

export default industries;
